export default "__VITE_ASSET__iRYYGPhA__"